import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Table } from "../../../../components/Table";
import { Api } from "../../../../services/api";
import { AddMember } from "../../../../components/AddMember";
import { Container } from "./AddTeamMember.styles";
import { AddMembersType } from "../../../../components/AddMember/addMember";
import { getColumns } from "../../Members/columnData";
import {
  selectMemberMap,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/hooks";
import { setMembers } from "../../../../store/slices/MemberListSlice";
import { Member, RoleMembers } from "../../../../services/api/types/Roles";

const testData = new Array<Member>();

export const AddTeamMember = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.auth.token);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableData] = useState<Array<Member>>(testData);

  const history = useHistory();
  const { officeId } = useParams<{ officeId: string }>();

  //pull member and teamTypes from redux
  const members = selectMemberMap();

  useEffect(() => {
    fetchOffice();
  }, [officeId]);

  //TODO what is going on here??????
  const fetchOffice = async () => {
    try {
      await Api.offices.getOffice(officeId);
      //setTableData(response.data.offices);
      setIsLoading(false);
    } catch (e) {
      console.error("Fetch Office Error:", e);
    }
  };

  const navigateToEdit = () => {
    const currentLocation = history.location;
    currentLocation.pathname =
      currentLocation.pathname.split("/").slice(0, -1).join("/") + "/edit";
    history.push(currentLocation);
  };

  const submitValues = (values: AddMembersType) => {
    if (!values.members) return;
    const data: RoleMembers = {
      members: [
        ...tableData.map(member => member.id),
        ...values.members.map(name => members.get(name as string)?.id || ""),
      ],
    };

    try {
      Api.offices.updateTeamMembers(officeId, data).then(() => {
        Api.members
          .getMembers()
          .then(res => {
            dispatch(setMembers(res.data));
          })
          .catch(() => {
            dispatch(setMembers([]));
          });
        navigateToEdit();
      });
    } catch (error) {
      console.error("Update Team Member:", error);
    }
  };

  const handleCancel = () => {
    navigateToEdit();
  };

  return (
    <Container>
      {!isLoading ? (
        <>
          <AddMember
            header={"Add Members"}
            handleCancel={handleCancel}
            submitValues={submitValues}
          />
          <div style={{ width: "100%" }}>
            <Table
              editable
              tableType="Members"
              isLoading={isLoading}
              defaultRows={20}
              columns={getColumns(token)}
              rowsPerPage={[10, 20, 35, 50]}
              data={tableData}
            />
          </div>
        </>
      ) : null}
    </Container>
  );
};
